export default {"src":"/_next/static/media/india_flag.c3ee7db5.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};